module.exports = {
  LOGO: ['SkillShape,', 'your path revealed'],
  MAIN: {
    SEO_TITLE: 'SkillShape Landing Page',
    // First screen
    MENU: 'menu',
    BACKGROUND_ALT: 'Background',
    HERO_TEXT: [
      'We help ', /* martial arts schools and gyms */
      /* Location */ ' build ',
      /* Stronger */ ' world.',
      'We give you the free tools. You just have to teach.',
    ],
    THEME: {
      0: {
        title: 'martial arts schools and gyms',
        make: 'Stronger',
        a: 'a',
      },
      1: {
        make: 'Balanced',
        title: 'Yoga and Pilates schools',
        a: 'a',
      },
      2: {
        make: 'Expressive',
        title: 'Dance and Art schools',
        a: 'an',
      },
    },
    BTN_STUDENT: 'I am a student',
    BTN_SCHOOL: 'Sign up as a school',
    HURRY_UP: ['It\'s free forever for a limited number of', ' new schools, ', 'So Sign Up today!'],
    BTN_LEARN_MORE: 'Learn More',

    // Sidebars
    SIGN_UP_SIDEBAR: {
      TITLE: 'Sign up for SkillShape',
      INPUT: {
        EMAIL: 'Email',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm password',
      },
      PLACEHOLDER: {
        EMAIL: 'email@example.com',
        PASSWORD: '******',
        CONFIRM_PASSWORD: '******',
      },
      CHECKBOX: {
        TERMS: ['I agree to SkillShape ', 'terms & conditions'],
        NEWS: 'I would like to receive news and updates about SkillShape.',
      },
      SIGN_UP_BUTTON: 'Sign Up',
      SIGN_IN_BUTTON: 'I already have an account, log in.',
    },
    SIGN_IN_SIDEBAR: {
      INPUT: {
        EMAIL: 'Email',
        PASSWORD: 'Password',
      },
      PLACEHOLDER: {
        EMAIL: 'email@example.com',
        PASSWORD: '******',
      },
      SIGN_IN_BUTTON: 'Log in',
      SIGN_UP_BUTTON: "I don't have an account, register.",
      FORGOT_PASSWORD: 'Forgot password?',
    },
    FORGOT_SIDEBAR: {
      TITLE: 'Forgot Password',
      RESET_LINK: 'Password reset link has been sent to your email!',
      INPUT: {
        EMAIL: 'Email',
      },
      PLACEHOLDER: {
        EMAIL: 'email@example.com',
      },
      SUBMIT_BUTTON: 'Submit',
      SIGN_UP_BUTTON: "I don't have an account, register.",
    },

    // Second screen
    IMAGES_ALT: {
      OPTION: 'Option',
    },
  },
  NOT_FOUND: {
    TITLE: 'NOT FOUND',
    SEO_TITLE: '404: Not found',
    BODY: "You just hit a route that doesn't exist... the sadness.",
  },
  FOOTER_TEXT: [
    'Join for free',
    'SkillShape has given me the freedom to think about future of my school rather than being swamped under administrative chores.',
    ' – Dr. Mark Marlow',
    'Founder MMA Gym',
  ],
  SOCIAL: {
    SIGN_UP: {
      GOOGLE_TEXT: 'Sign up with Google',
      FACEBOOK_TEXT: 'Sign up with facebook',

    },
    LOGIN: {
      GOOGLE_TEXT: 'Login with Google',
      FACEBOOK_TEXT: 'Login with facebook',
    },
  },
};
